import { BsHeaderTab } from './BsHeaderTab';
export default BsHeaderTab;
